
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageDataFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publicId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hashedPublicId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"href"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPinnable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audience"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":167}};
    doc.loc.source = {"body":"fragment ImageDataFragment on ImageData {\n  url\n  publicId\n  hashedPublicId\n  alt\n  caption\n  credit\n  href\n  isPinnable\n  originalWidth\n  originalHeight\n  audience\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
